// extracted by mini-css-extract-plugin
export default {"heading":"TableHeading_heading__52j3L"};